import { api, apiBlob, apiUpload } from './client';
import type { AttachmentDto } from './types';

export function listAttachments(taskId: string): Promise<AttachmentDto[]> {
  return api<AttachmentDto[]>(`/tasks/${taskId}/attachments`);
}

export function uploadAttachment(taskId: string, file: File): Promise<AttachmentDto> {
  const formData = new FormData();
  formData.append('file', file);
  return apiUpload<AttachmentDto>(`/tasks/${taskId}/attachments`, formData);
}

export function deleteAttachment(attachmentId: string): Promise<void> {
  return api<void>(`/attachments/${attachmentId}`, { method: 'DELETE' });
}

export function getAttachmentBlob(attachmentId: string): Promise<Blob> {
  return apiBlob(`/attachments/${attachmentId}/content`);
}
